import React, { useState } from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import YupPassword from 'yup-password';

import Button from 'CommonComponents/Button';
import Toast from 'CommonComponents/Toast';

YupPassword(Yup);

const userSecuritySchema = Yup.object().shape({
    old_password: Yup.string().max(64).required('This value is required'),
    password: Yup.string().required('This value is required').min(10).max(64).minNumbers(1).minUppercase(1).minLowercase(1).minSymbols(1),
    password_confirmation: Yup.string()
        .required('This value is required')
        .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export default function UserPersonalDetailsSecurityForm(props) {
    const [message, setMessage] = useState('');
    const [toastId, setToastId] = useState('user-change-password');

    return (
        <div>
            <Formik
                initialValues={{
                    old_password: '',
                    password: '',
                    password_confirmation: '',
                }}
                validationSchema={userSecuritySchema}
                onSubmit={(values, actions) => {
                    let data = { ...values };
                    axios
                        .put(props.changePasswordUrl, data)
                        .then((response) => {
                            setMessage('Password has been successfully changed');
                            setTimeout(() => {
                                $(`#${toastId}`).toast('show');
                            }, 0);
                            actions.resetForm();
                        })
                        .catch((e) => {
                            actions.setErrors(e.response.data.errors);
                            setMessage('Something went wrong');
                            setTimeout(() => {
                                $(`#${toastId}`).toast('show');
                            }, 0);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                }}
            >
                {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue, isValid, validateForm }) => (
                    <div>
                        <div className={'row'}>
                            <div className={'col-12'}>
                                <div className={'card bg-white border-0 rounded-15px py-2 shadow'}>
                                    <div className="">
                                        <div className={'card-body'}>
                                            <div className="form-group row">
                                                <label htmlFor="old_password" className="col-12 col-form-label font-weight-bold" style={{ fontSize: '14px' }}>
                                                    Current password
                                                </label>
                                                <div className="col-12">
                                                    <Field
                                                        type="password"
                                                        className={
                                                            errors.old_password && touched.old_password
                                                                ? 'form-control is-invalid border border-danger'
                                                                : 'form-control'
                                                        }
                                                        name="old_password"
                                                        placeholder="Current password"
                                                    />
                                                    {errors.old_password && touched.old_password && <div className="text-danger">{errors.old_password}</div>}
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="password" className="col-12 col-form-label font-weight-bold" style={{ fontSize: '14px' }}>
                                                    Password
                                                </label>
                                                <div className="col-12">
                                                    <Field
                                                        type="password"
                                                        className={
                                                            errors.password && touched.password
                                                                ? 'form-control is-invalid border border-danger'
                                                                : 'form-control'
                                                        }
                                                        name="password"
                                                        placeholder="password"
                                                    />
                                                    {errors.compromised && (
                                                        <div className="text-danger">
                                                            {$t('The current password appears to be insecure, please choose a new one')}.
                                                        </div>
                                                    )}
                                                    {!errors.old_password && errors.password && touched.password && (
                                                        <div className="text-danger">
                                                            {$t(
                                                                'The current password does not meet the required complexity requirements. Please enter a password between 10-64 characters in length, which includes at least one number, one uppercase letter, one symbol. It may not be any of your previously used passwords.',
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    htmlFor="password_confirmation"
                                                    className="col-12 col-form-label font-weight-bold"
                                                    style={{ fontSize: '14px' }}
                                                >
                                                    Confirm Password
                                                </label>
                                                <div className="col-12">
                                                    <Field
                                                        type="password"
                                                        className={
                                                            errors.password_confirmation && touched.password_confirmation
                                                                ? 'form-control is-invalid border border-danger'
                                                                : 'form-control'
                                                        }
                                                        name="password_confirmation"
                                                        placeholder="password"
                                                    />
                                                    {errors.password_confirmation && touched.password_confirmation && (
                                                        <div className="text-danger">{errors.password_confirmation}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-end">
                                                    <Button
                                                        variant="primary"
                                                        disabled={isSubmitting || !isValid}
                                                        onClick={() =>
                                                            validateForm().then(() => {
                                                                if (isValid) {
                                                                    handleSubmit();
                                                                }
                                                            })
                                                        }
                                                    >
                                                        Change password
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Formik>
            <Toast id={toastId} message={message}></Toast>
        </div>
    );
}
